import React, { useState, useRef } from 'react';
import MicIcon from '@mui/icons-material/Mic';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { pink } from '@mui/material/colors';
import { Height } from '@mui/icons-material';
import { IoIosMic, IoIosPause } from "react-icons/io";

const VoiceRecorder = ({ setAudioBlob, isRecording, setIsRecording }) => {
    // const [isRecording, setIsRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audioUrl, setAudioUrl] = useState('');
    const streamRef = useRef(null);

    const startRecording = (event) => {
        event.preventDefault();
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                const recorder = new MediaRecorder(stream);
                setMediaRecorder(recorder);
                streamRef.current = stream;

                const chunks = [];
                recorder.ondataavailable = (event) => {
                    chunks.push(event.data);
                };

                recorder.onstop = () => {
                    const audioBlob = new Blob(chunks, { type: 'audio/wav' });
                    setAudioBlob(audioBlob);
                };

                recorder.start();
                setIsRecording(true);
            })
            .catch((err) => console.error('Could not get user media:', err));
    };

    const stopRecording = (event) => {
        event.preventDefault();
        if (mediaRecorder) {
            mediaRecorder.stop();
            setIsRecording(false);
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
            }
        }
    };

    return (
        <>
            <button
                className="source-tw-p-3 source-tw-rounded-r-lg source-tw-focus:outline-none source-tw-outline-none source-tw-border-none hover:source-tw-scale-110 "
                title="record"
                style={{ color: `${isRecording ? 'red' : 'rgb(67, 183, 93)'}`, cursor: 'pointer', backgroundColor: 'transparent' }}
                onClick={isRecording ? stopRecording : startRecording}
            >
                {isRecording ? <IoIosPause size={'26px'} /> : <IoIosMic size={'26px'} />}
            </button >

            {/* <button class="source-tw-p-3 source-tw-rounded-r-lg source-tw-focus:outline-none source-tw-outline-none source-tw-border-none hover:source-tw-scale-110" title="Send" style={{ color: 'rgb(67, 183, 93)', cursor: 'pointer', backgroundColor: 'transparent' }}>

                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" data-testid="MicIcon" focusable="false" aria-hidden="true">
                    <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3m5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72z"></path>
                </svg>
            </button> */}



        </>
    );

};

export default VoiceRecorder;
